<template>
    <div>
        <Order />
    </div>
</template>

<script>
import Order from "./orderView.vue";
export default {
    components: {
        Order,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
